import React from 'react';
import { useSelector } from 'react-redux';
import classes from './AfterFinalMessage.module.css';

export const AfterFinalMessage = () => {

    const { texts } = useSelector((state) => state.translate);

    return (
        <div className={classes.afterFinalMessage}>
            <p className={classes.text1} >{texts.afterFinalMessageText1}</p>
            <p className={classes.text2} >{texts.afterFinalMessageText2}</p>
            <p className={classes.text3} >{texts.afterFinalMessageText3}</p>
        </div>
    );
};
export default AfterFinalMessage;